<template>
    <div id="setQuestionnaire">
        <div class="layout-content">
            <div class="layout-content-title">
                <div class="breadcrumb">
                    <svg class="iconpark-icon" @click="to({ path: backPath })">
                        <use href="#fanhui"></use>
                    </svg>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: backPath }"> {{ typeName }}列表 </el-breadcrumb-item>
                        <el-breadcrumb-item>创建{{ typeName }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="handleBtn">
                    <el-popover placement="bottom-end" width="200" trigger="hover"
                        popper-class="setQuestionnaireQrCode">
                        <el-button slot="reference">
                            <svg class="iconpark-icon">
                                <use href="#chakan"></use>
                            </svg>
                            <span>预览</span>
                        </el-button>
                        <div class="setQuestionnaireQrCodeBox">
                            <img :src="qrcodeUrl" alt="" />
                            <div>
                                <span>保存后扫码预览或</span>
                                <span class="preview" @click="showHandle">直接预览</span>
                            </div>
                        </div>
                    </el-popover>
                    <el-button type="primary" @click="submitForm(1)"> 保存 </el-button>
                    <el-button v-if="type === 0" type="primary" @click="submitForm()">
                        {{ !questionnaireForm.status ? '发布' : '取消发布' }}
                    </el-button>
                </div>
            </div>
            <div class="layout-container">
                <div class="container_left">
                    <options ref="options" :type="type" @add="addQuestion" @remove="removeQuestion" />
                </div>
                <div class="container_right">
                    <el-form ref="questionnaireForm" :model="questionnaireForm">
                        <draggable class="baseSortContainer" v-model="baseSort" group="baseInfo" handle=".baseMoveIcon" @start="baseDrag = true" @end="baseDrag = false">
                            <div v-for="(item, index) in baseSort" :key="index" class="baseItem">
                                <div v-if="item === baseTypes.poster" class="posterUploader">
                                    <el-upload v-loading="uploading" action="" :show-file-list="false"
                                        :http-request="uploadImg" accept="image/jpeg,image/png,">
                                        <template v-if="posterUrl">
                                            <i class="el-icon-close" @click.stop="removePoster"></i>
                                            <img :src="posterUrl" alt="" class="rawImg" />
                                            <img :src="posterUrl" alt="" class="filterBlur" />
                                        </template>
                                        <template v-else>
                                            <div class="defaultImg" />
                                            <div v-if="!posterUrl" class="tips">
                                                <svg class="iconpark-icon">
                                                    <use href="#tianjiatupian"></use>
                                                </svg>
                                                <p>添加图片，2MB以内，图片支持JPEG/PNG/GIF</p>
                                            </div>
                                        </template>
                                    </el-upload>
                                    <div class="handleBar">
                                        <el-tooltip class="item" effect="dark" content="移动" placement="top">
                                            <svg class="iconpark-icon baseMoveIcon">
                                                <use href="#yidong"></use>
                                            </svg>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <div v-if="item === baseTypes.title" class="title formItem">
                                    <el-form-item :rules="[
                                        {
                                            min: 0,
                                            max: 100,
                                            message: '长度在 0 到 100 个字符',
                                            trigger: 'blur',
                                        },
                                    ]" prop="title">
                                        <el-input v-model="questionnaireForm.title" :autofocus="true"
                                            :placeholder="`请输入${typeName}标题`" @blur="titleHintShow = true" />
                                    </el-form-item>
                                    <div class="handleBar">
                                        <el-tooltip class="item" effect="dark" content="移动" placement="top">
                                            <svg class="iconpark-icon baseMoveIcon">
                                                <use href="#yidong"></use>
                                            </svg>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <div v-if="item === baseTypes.description" class="title formItem">
                                    <el-form-item :rules="[
                                        {
                                            min: 0,
                                            max: 800,
                                            message: '长度在 0 到 800 个字符',
                                            trigger: 'blur',
                                        },
                                    ]" prop="description">
                                        <el-input v-model="questionnaireForm.description" type="textarea" autosize
                                            resize="none" :autofocus="true" placeholder="请输入简介"
                                            @blur="descriptionHintShow = true" />
                                    </el-form-item>
                                    <div class="handleBar">
                                        <el-tooltip class="item" effect="dark" content="移动" placement="top">
                                            <svg class="iconpark-icon baseMoveIcon">
                                                <use href="#yidong"></use>
                                            </svg>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </draggable>



                        <div v-if="questionnaireForm.surveyQuestions.length === 0" class="formItem">
                            <el-form-item id="addHint" class="el_form_item">
                                <svg class="iconpark-icon">
                                    <use href="#tianjiaxuanxiang"></use>
                                </svg>
                                <p>点击左侧菜单选项添加内容</p>
                            </el-form-item>
                        </div>
                        <!-- ********************************************************************************************************************************************************************************************************************************************************************************************************** -->
                        <div v-for="(item, index) in questionnaireForm.surveyQuestions" :key="index" ref="dragBox"
                            :draggable="isDrag" class="dragBox" @dragstart="ondragstart($event, index)"
                            @dragleave="ondragleave($event, index)" @dragover="ondragover($event, index)"
                            @dragend="ondragend($event, index)" @mouseup="isDrag = false" @drop="ondrop">
                            <el-form-item :prop="`surveyQuestions[${index}].title`" :rules="[
                                { required: true, message: '请输入问题', trigger: 'blur' },
                                {
                                    min: 1,
                                    max: 100,
                                    message: '长度在 1 到 100 个字符',
                                    trigger: 'blur',
                                },
                            ]" class="hintItem el_form_item">
                                <div class="index">{{ index > 98 ? '99+' : index + 1 }}.</div>
                                <el-checkbox v-model="item.required" class="requiredBtn">
                                    必填
                                </el-checkbox>
                                <div class="moveAndDelete">
                                    <el-tooltip class="item" effect="dark" content="移动" placement="top">
                                        <svg v-if="item.type !== 8" class="iconpark-icon" @mouseenter="isDrag = true"
                                            @mouseleave="isDrag = false" @mousedown="onmousedown" @drop="ondrop">
                                            <use href="#yidong"></use>
                                        </svg>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                        <svg class="iconpark-icon" @click="deleteQuestion(index)">
                                            <use href="#shanchu"></use>
                                        </svg>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="复制" placement="top">
                                        <svg v-if="![8, 9].includes(item.type)" class="iconpark-icon" aria-hidden="true"
                                            @click="copyQuestion(index)">
                                            <use xlink:href="#fuzhi" />
                                        </svg>
                                    </el-tooltip>
                                </div>
                                <el-input v-model="item.title" :value="item | typeFilters" class="titleInput" />
                                <div v-if="item.type === 4" style="margin-top: 12px" class="simulationUpload">
                                    <svg class="iconpark-icon">
                                        <use href="#tianjiatupian"></use>
                                    </svg>
                                    <span>上传图片</span>
                                </div>
                                <el-input v-else-if="[9].includes(item.type)" v-model="item.inviteCode"
                                    style="margin-top: 20px" placeholder="请输入邀请码（多个邀请码用逗号，隔开)" @blur="
										if (item.inviteCode) {
                                        item.inviteCode = item.inviteCode.replace(/\，/g, ',');
                                    }
                                        " />
                                <el-input v-else-if="[12].includes(item.type)" :disabled="true" style="margin-top: 20px"
                                    placeholder="请选择地区" />
                                <el-input v-else-if="![1, 2, 8, 11, 98].includes(item.type)" :disabled="true"
                                    style="margin-top: 20px" placeholder="请输入您的回答" />
                                <el-input v-else-if="[98].includes(item.type)" :disabled="true"
                                    style="margin-top: 20px" placeholder="请选择医院" />
                                <div v-if="[9].includes(item.type)" class="survey_operate">
                                    <el-upload v-if="item.type === 9" ref="fcCodeUpload" action="" :auto-upload="false"
                                        :show-file-list="false" :on-change="fcCodeFile" class="btn"
                                        @click.native="uploadIndex(index)">
                                        <span>
                                            <svg class="iconpark-icon">
                                                <use href="#daoru"></use>
                                            </svg>
                                            <span>导入</span>
                                        </span>
                                        <input ref="fcCodeUpload" style="display: none" type="file" accept=""
                                            @change="fcCodeFile" />
                                    </el-upload>
                                    <span class="line"></span>
                                    <!-- <span class="btn" @click="item.inviteCode = ''">清空</span> -->
                                    <a target="_blank" download
                                        href="https://s.tuwenzhibo.com/static/invite_code_template.xlsx" class="btn">
                                        <svg class="iconpark-icon">
                                            <use href="#xiazai"></use>
                                        </svg>
                                        <span>下载模版</span>
                                    </a>
                                </div>

                                <div class="edit_box" v-if="item.type === 8">
                                    <div class="edit_form-item">
                                        <div>用户协议标题：</div>
                                        <el-input placeholder="用户须知" v-model="item.userAgreementName" />
                                    </div>
                                    <div class="edit_form-item">
                                        <div>用户协议正文：</div>
                                        <quill-editor ref="newEditor" :class="{ screenQuillEditor: showScreen }"
                                            :options="editorOption" :content="item.userAgreement"
                                            @change="onEditorChange($event, item)" />
                                        <input ref="editorUpload" type="file" hidden accept="image/*"
                                            @change="(e) => headImgChange(e, item)" />
                                        <i v-if="!showScreen" class="el-icon-full-screen screen" @click="screen" />
                                        <i v-if="showScreen" class="el-icon-full-screen closescreen"
                                            @click="closeScreen" />
                                    </div>

                                </div>
                                <div v-if="item.title === '手机' && item.disabled == 1" class="switchGroup">
                                    <div class="sms_code_switch">
                                        <span>是否开启短信验证</span>
                                        <el-switch v-model="item.isOpenSms" class="switch"
                                            @change="smsOpenStatusChange($event, item)" />
                                    </div>
                                    <div class="sms_code_tips_wrap">
                                        <div v-if="smsAssets" class="sms_code_num">
                                            <template v-if="smsAssets.isFree">
                                                可用短信条数：
                                                <template v-if="smsAssets.remainSmsNum">
                                                    <span class="num">{{ smsCodeNum }}</span>条 （{{
                                                        timeFormat(smsAssets.smsFreeDueDate, 'YYYY-MM-DD')
                                                    }}前不扣除短信条数）
                                                    <el-tooltip effect="dark" content="老用户会员期内限时免费，会员到期后按需购买"
                                                        placement="top">
                                                        <i class="tip_icon iconfont icon-wenhao1"></i>
                                                    </el-tooltip>
                                                </template>
                                                <template v-else>
                                                    不限（{{ timeFormat(smsAssets.smsFreeDueDate, 'YYYY-MM-DD') }}到期)
                                                    <el-tooltip effect="dark" content="老用户会员期内限时免费，会员到期后按需购买"
                                                        placement="top">
                                                        <i class="tip_icon iconfont icon-wenhao1"></i>
                                                    </el-tooltip>
                                                </template>
                                            </template>
                                            <template v-else>
                                                可用短信条数：<span class="num">{{ smsCodeNum }}</span>条
                                            </template>
                                            <a :href="smsCodeBuyUrl" class="buy_link">去购买 <i
                                                    class="icon iconfont icon-xiala1"></i></a>
                                        </div>
                                        <div class="sms_code_tips">
                                            短信包余额不足时，将无法使用该功能，为保证活动正常进行请确保短信包余额充足
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                            <div v-for="(optionContentItem, optionContentIndex) in item.optionContent"
                                :key="optionContentIndex" class="optionItem">
                                <el-form-item
                                    :prop="`surveyQuestions[${index}].optionContent[${optionContentIndex}].value`"
                                    :rules="[
                                        { required: true, message: '请输入选项', trigger: 'blur' },
                                        {
                                            min: 1,
                                            max: 100,
                                            message: '长度在 1 到 100 个字符',
                                            trigger: 'blur',
                                        },
                                        { validator: validatePass, trigger: 'blur' },
                                    ]" class="hintItem el_form_item">
                                    <el-input v-if="optionContentItem.type === 0"
                                        v-model="item.optionContent[optionContentIndex]['value']"
                                        :value="optionContentItem.value" placeholder="请输入选项内容" />
                                    <div v-else class="otherInput">
                                        <el-input v-model="item.optionContent[optionContentIndex]['value']"
                                            :value="optionContentItem.value" placeholder="其他" />
                                        <span class="line" />
                                    </div>
                                    <svg v-if="item.type !== 0 && item.type !== 4" class="iconpark-icon"
                                        aria-hidden="true" @click="deleteOption(index, optionContentIndex)">
                                        <use xlink:href="#shanchu1" />
                                    </svg>
                                </el-form-item>
                            </div>
                            <div v-if="[1, 2, 11].includes(item.type)" class="add survey_operate">
                                <a class="addOption" @click="addOption(0, index)">
                                    <svg class="iconpark-icon">
                                        <use href="#tianjia"></use>
                                    </svg>
                                    <span>添加选项</span>
                                </a>
                                <span v-if="item.type === 11" class="line"></span>
                                <el-upload v-if="item.type === 11" class="btn" action=""
                                    :http-request="(e) => uploadSelect(e, index)" :show-file-list="false">
                                    <span>
                                        <svg class="iconpark-icon">
                                            <use href="#daoru"></use>
                                        </svg>
                                        <span>导入</span>
                                    </span>
                                </el-upload>
                                <span v-if="![11].includes(item.type)" class="line"></span>
                                <a v-if="![11].includes(item.type)" class="addOtherOption" @click="addOption(1, index)">
                                    <svg class="iconpark-icon">
                                        <use href="#qitaxuanxiang"></use>
                                    </svg>
                                    <span>添加其他选项</span>
                                </a>
                                <span v-if="[2].includes(item.type)" class="line"></span>
                                <a v-if="[2].includes(item.type)" class="maxChoose">
                                    <svg class="iconpark-icon">
                                        <use href="#qitaxuanxiang"></use>
                                    </svg>
                                    <span>最多可选</span>
                                    <el-input-number v-model="item.optionalLimit" :min="0"
                                        :max="item.optionContent.length" label="描述文字" size="mini">
                                    </el-input-number>
                                    <span class="tips">“0”为不限制</span>
                                </a>
                            </div>
                        </div>
                        <!-- ********************************************************************************************************************************************************************************************************************************************************************************************************** -->
                        <!-- <hint-item v-for="item in questionnaireForm.surveyQuestions" :surveyQuestionsItem="item"></hint-item> -->
                    </el-form>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="showTips" title="问卷图片" width="660px" class="tipsDialog">
            <p>
                问卷图片就是问卷内的banner，图片上传后在移动端{{ typeName }}内置顶显示。内容可涵盖直播主题，时间，地点及主办方等信息。
                <span style="font-size: 14px; color: #ff4b40">（建议尺寸900*500px）</span>
            </p>
            <p>问卷图片显示位置如下</p>
            <img src="@/assets/img/preview.png" alt="" />
        </el-dialog>
        <sms-dialog-tips ref="smsDialogTips" />
    </div>
</template>
<script>
// import hintItem from '../../components/hintItem.vue';
import { user, survey, upload } from '@/services';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { quillEditor, Quill } from 'vue-quill-editor';
const Font = Quill.import('formats/font');
var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif'];
Font.whitelist = fonts;
Quill.register(Font, true);
import conf from '@/config';
import { mapActions, mapGetters, mapState } from 'vuex';
import dateFormat from 'ourwill-feutil/common/dateFormat';
import options from '@/components/options';
import draggable from 'vuedraggable'

const baseTypes = {
    poster: 1,
    title: 2,
    description: 3,
}

export default {
    components: {
        quillEditor,
        smsDialogTips: () => import('@/components/smsDialogTips.vue'),
        options,
        draggable,
    },
    filters: {
        typeFilters(val) {
            let lastValue = null;
            if (val.title === '') {
                switch (val.type) {
                    case 1:
                        lastValue = '单选题';
                        break;
                    case 2:
                        lastValue = '多选题';
                        break;
                }
            } else {
                lastValue = val.title;
            }
            return lastValue;
        },
    },
    data() {
        return {
            addImgRange: '',
            showScreen: false,
            //编辑器配置
            editorOption: {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline'],
                        ['link', 'image'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ color: [] }, { background: [] }],
                        [{ script: 'sub' }, { script: 'super' }],
                        [{ size: ['small', false, 'large', 'huge'] }],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    ],
                },
                theme: 'snow',
                placeholder: '请输入需要填写的内容',
            },
            showTips: false,

            posterUrl: '',
            bgPicture: '',
            uploading: false,
            visitSource: 1,
            type: 0, //问卷类型

            //必填选中状态
            checked: '',
            //******************************** */
            titleHintShow: true,
            descriptionHintShow: true,
            //问卷Form表单
            questionnaireForm: {
                type: '', //问卷类型
                title: '', //问卷标题
                description: '', //问卷描述
                visitType: 0, //活动类型（0：所有活动，1：活动发布，2：活动关闭）
                activityId: '', //会议id,当且仅当 vistitType=1,设置此值
                sendWay: '', //发送方式（0，短信，1，电子邮件，2，公众号推送）
                surveyQuestions: [
                    //	问卷问题集合
                ],
                deadLine: '', //截止时间
                submitHold: true, //提交按钮拦截
                baseSort: ''
            },
            //问卷设置弹出框
            setDialogVisible: false,
            setDateChecked: false, //设置截止日期选中状态
            setAddressableChecked: false, //设置可访问人群选中状态
            // endTime: '', //截止日期
            visitType: 0, //活动类型
            sendWay: '', //发送方式
            activityId: '', //活动列表
            bindActivity: false, //关联活动

            visitOptions: [
                {
                    value: 0,
                    label: '所有活动',
                },
                {
                    value: 1,
                    label: '未开始',
                },
                {
                    value: 2,
                    label: '已结束',
                },
                {
                    value: 3,
                    label: '进行中',
                },
            ],
            listOptions: [],
            sendOptions: [
                // {
                // 	value: 0,
                // 	label: '短信'
                // },
                {
                    value: 1,
                    label: '电子邮件',
                },
                // {
                // 	value: 2,
                // 	label: '公众号推送'
                // }
            ],
            isDrag: false, //是否拖拽
            dragStartIndex: '',
            dragEndIndex: '',

            publishShow: true, //发布是否显示
            showResult: 0, //投票是否显示结果
            uploadInviteCodeIndex: null, //上传的邀请码的index

            baseTypes,
            baseDrag: false,
        };
    },
    computed: {
        ...mapState({
            smsAssets: (state) => state.smsConsumeRecord.smsAssets,
        }),
        ...mapGetters({
            haveSmsAssets: 'smsConsumeRecord/haveSmsAssets',
        }),
        baseSort: {
            get() {
                if (this.questionnaireForm.baseSort) {
                    return this.questionnaireForm.baseSort.split(',').map(item => Number(item));
                }
                return [baseTypes.poster, baseTypes.title, baseTypes.description];
            },
            set(val) {
                this.questionnaireForm.baseSort = val.join(',');
            }
        },
        smsCodeNum() {
            return this.smsAssets && this.smsAssets.remainSmsNum ? this.smsAssets.remainSmsNum : 0;
        },
        smsCodeBuyUrl() {
            return '/views/toShortMessage';
        },
        qrcodeUrl() {
            const url = `${conf.surveyHost}/questionnaire/#/questionnaireVote/${this.$route.params.id}/show?preview=1`;
            return `${conf.ssrUrl}/qrcode/png/${btoa(url)}.png?s=200`;
        },
        typeName() {
            switch (this.type) {
                case 0:
                    return '报名表';
                case 1:
                    return '投票';
                case 2:
                    return '调查问卷';
            }
        },
        backPath() {
            switch (this.type) {
                case 0:
                    return '/signList';
                case 1:
                    return '/signList';
                case 2:
                    return '/question';
            }
        }
    },
    created() {
        if (this.$route.params.id !== 'noId') {
            const id = this.$route.params.id;
            this.getSingleInfo(id);
        } else {
            console.log('id不存在');
        }
        //创建时默认截止时间
        if (this.$route.params.handle === 'create') {
            const myDate = new Date();
            var year = myDate.getFullYear();
            var month = myDate.getMonth() + 2;
            if (month > 12) {
                month = 1;
                year = year + 1;
            }
            const day = myDate.getDate();
            const hours = myDate.getHours();
            const minutes = myDate.getMinutes();
            const seconds = myDate.getSeconds();
            const time = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            // console.log(time)
            this.questionnaireForm.deadLine = time;
        }
        if (this.$route.params.type) {
            const type = this.$route.params.type;
            this.type = type - 0;
        }
    },
    mounted() {
        this.getCurrentSmsAssets();
    },
    methods: {
        ...mapActions({
            getCurrentSmsAssets: 'smsConsumeRecord/getCurrentSmsAssets',
        }),
        removePoster() {
            this.posterUrl = '';
            this.bgPicture = '';
        },
        to(routeInfo) {
            this.$router.push(routeInfo);
        },
        smsOpenStatusChange(value, item) {
            if (value && !this.haveSmsAssets) {
                item.isOpenSms = false;
                this.$refs.smsDialogTips.show();
            }
        },
        timeFormat(value, format = 'YYYY-MM-DD HH:mm:ss') {
            return value ? dateFormat(value, format) : '——';
        },
        onEditorChange({ quill, html, text }, item) {
            var length = quill.getLength();
            if (length > 5001) {
                var delta = quill.getContents(0, 5000);
                quill.setContents(delta.ops);
                quill.deleteText(5000, 4);
                return this.$message.error('长度不能超过5000!');
            }
            item.userAgreement = html;
        },
        async headImgChange(e, item) {
            let file = e.target.files[0];
            const isLt = file.size / 1024 / 1024 < 8;
            if (!isLt) {
                this.$message.error('图片大小不能超过8M!');
                return;
            }

            let _item = item;
            console.log(item);
            let { ok, data } = await upload.uploadFile(0, file);

            if (ok) {
                _item.imgList ? _item.imgList.push(data.data) : (_item.imgList = [data.data]);
                this.$refs.newEditor[0].quill.insertEmbed(
                    this.addImgRange != null ? this.addImgRange.index : 0,
                    'image',
                    data.url,
                    Quill.sources.USER
                );
                this.$refs.editorUpload[0].value = '';
            }
        },
        screen() {
            this.showScreen = true;
        },
        closeScreen() {
            this.showScreen = false;
        },
        uploadImg({ file }) {
            const isLt = file.size / 1024 / 1024 < 2;
            if (!isLt) {
                return this.$message.error('图片大小不超过2M');
            }
            this.uploading = true;
            // var formData = new FormData();
            // formData.append('file', imgfile); //(name,value)
            upload.uploadFile(0, file).then(({ ok, data }) => {
                if (ok) {
                    this.posterUrl = data.url;
                    this.bgPicture = data.data;
                    this.uploading = false;
                }
            });
        },
        sourceSelect() { },
        // blurHandle(){
        // 		this.titleHintShow = true;
        // 		this.descriptionHintShow = true;
        // },
        ondrop(event) {
            console.log(event, 'event');
        },
        //拖拽事件
        ondragstart(event, index) {
            // console.log('ondragstart', index);
            this.dragStartIndex = index;
        },
        // ondragenter(event, index) {
        // 	console.log('ondragenter', index);
        // },
        ondragleave(event, index) {
            // console.log('ondragleave', index);
            this.dragEndIndex = index;
        },
        ondragover(event, index) { },
        ondragend(event, index) {
            const arr = [...this.questionnaireForm.surveyQuestions];
            const dragStartIndex = this.dragStartIndex;
            const dragEndIndex = this.dragEndIndex;
            arr.splice(dragStartIndex, 1);
            arr.splice(dragEndIndex, 0, this.questionnaireForm.surveyQuestions[dragStartIndex]);
            this.questionnaireForm.surveyQuestions = [...arr];
        },
        onmousedown() {
            var self = this;
            var dragItems = document.querySelectorAll('[draggable=true]');
            // console.log(dragItems);
            for (var i = 0; i < dragItems.length; i++) {
                let dropIndex = i;
                const userAgent = navigator.userAgent;
                const isFF = userAgent.indexOf('Firefox') > -1;

                if (isFF) {
                    dragItems[i].ondragstart = function (dragStartEvent) {
                        //火狐浏览器得携带信息才能进行拖拽，但是会打开新的页面
                        dragStartEvent.dataTransfer.setData('text', '111');
                    };

                    dragItems[i].ondrop = function (dropEvent) {
                        console.log(dropEvent, 'this');
                        // console.log(dropIndex)
                        //阻止打开新的页面
                        dropEvent.stopPropagation();
                        dropEvent.preventDefault();
                        // dropEvent.dataTransfer = dropEvent.originalEvent.dataTransfer;
                    };
                }
            }
        },
        initQuill() {
            if(this.$refs.newEditor && this.$refs.newEditor.length) {
                var imgHandler = async (image) => {
                    this.addImgRange = this.$refs.newEditor[0].quill.getSelection();
                    if (image) {
                        this.$refs.editorUpload[0].click();
                    }
                };
                this.$refs.newEditor[0].quill.getModule('toolbar').addHandler('image', imgHandler);
            }
            
        },
        //获取单个详情信息
        getSingleInfo(id) {
            survey.getSingleInfo(id).then(({ data, ok }) => {
                if (ok) {
                    data.data.surveyQuestions.forEach((item) => {
                        item.optionContent = JSON.parse(item.optionContent);
                        if (item.type === 9) {
                            if (item.inviteCode) {
                                item.inviteCode = item.inviteCode.join(',');
                            }
                        }
                    });
                    this.posterUrl = data.data.url;
                    this.bgPicture = data.data.bgPicture;
                    this.questionnaireForm = data.data;
                    this.questionnaireForm.surveyQuestions.forEach((item) => {
                        item.required = item.required ? true : false;
                    });

                    if (this.questionnaireForm.showResult === 1) {
                        this.showResult = 1;
                    } else {
                        this.showResult = 0;
                    }

                    if (!this.questionnaireForm.activityId) {
                        this.questionnaireForm.activityId = null;
                        this.bindActivity = false;
                    }
                    //其他项置灰处理
                    this.questionnaireForm.surveyQuestions.forEach((item, index) => {
                        let haveOther = false;
                        item.optionContent.forEach((optionItem, optionIndex) => {
                            if (optionItem.type == 1) {
                                haveOther = true;
                            }
                        });
                        if (haveOther) {
                            this.$nextTick(() => {
                                const otherOption = document
                                    .querySelectorAll('.dragBox')
                                [index].querySelector('.addOtherOption');
                                otherOption.style.color = '#c2c5cc';
                            });
                        }
                    });
                    // 常规选项
                    this.$refs.options.initRoutine(this.questionnaireForm.surveyQuestions);
                    this.$nextTick(() => {
                        this.initQuill();
                    });
                }
                // console.log(res)
            });
        },
        //获取数据统计单个详情信息
        // geteditorView()
        //添加问题
        addQuestion(type) {
            if (type === 'protocal') {
                let p = this.questionnaireForm.surveyQuestions.map((item) => {
                    return item.type === 8;
                });

                if (p.some((i) => i)) {
                    this.$message.error('只能有一个协议');
                    return;
                }
            }

            let protocal;
            let protocalIndex;
            this.questionnaireForm.surveyQuestions.map((item, index) => {
                if (item.type === 8) {
                    protocal = item;
                    protocalIndex = index;
                }
            });

            if (protocal) {
                this.questionnaireForm.surveyQuestions.splice(protocalIndex);
            }

            switch (type) {
                case 0:
                    this.questionnaireForm.surveyQuestions.push({
                        title: '文本框',
                        type: 0,
                        optionContent: [],
                        disabled: 0,
                        required: false,
                    });
                    break;
                case 13:
                    this.questionnaireForm.surveyQuestions.push({
                        title: '数字框',
                        type: 13,
                        optionContent: [],
                        disabled: 0,
                        required: false,
                    });
                    break;
                case 99:
                    this.questionnaireForm.surveyQuestions.push({
                        title: '定制数字框',
                        type: 99,
                        optionContent: [],
                        disabled: 0,
                        required: false,
                    });
                    break;
                case 98:
                    this.questionnaireForm.surveyQuestions.push({
                        title: '医院',
                        type: 98,
                        questionContent: 'hospital',
                        optionContent: [],
                        disabled: 0,
                        required: false,
                    });
                    break;
                case 1:
                    this.questionnaireForm.surveyQuestions.push({
                        title: '单选题',
                        disabled: 0,
                        type: 1,
                        optionContent: [
                            {
                                type: 0,
                                value: '',
                            },
                            {
                                type: 0,
                                value: '',
                            },
                        ],
                        required: false,
                    });
                    break;
                case 2:
                    this.questionnaireForm.surveyQuestions.push({
                        title: '多选题',
                        disabled: 0,
                        type: 2,
                        optionContent: [
                            {
                                type: 0,
                                value: '',
                            },
                            {
                                type: 0,
                                value: '',
                            },
                        ],
                        optionalLimit: 0,
                        required: false,
                    });
                    break;
                case 4:
                    this.questionnaireForm.surveyQuestions.push({
                        title: '上传图片',
                        type: 4,
                        optionContent: [],
                        disabled: 0,
                        required: false,
                    });
                    break;
                case 11:
                    this.questionnaireForm.surveyQuestions.push({
                        title: '下拉选择',
                        disabled: 0,
                        type: 11,
                        optionContent: [
                            {
                                type: 0,
                                value: '',
                            },
                            {
                                type: 0,
                                value: '',
                            },
                        ],
                        required: false,
                    });
                    break;
                case 'name':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '姓名',
                        type: 0,
                        questionContent: 'name',
                        optionContent: [],
                        disabled: 1,
                        required: false,
                    });
                    break;
                case 'sex':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '性别',
                        type: 0,
                        questionContent: 'sex',
                        optionContent: [],
                        disabled: 1,
                        required: false,
                    });
                    break;
                case 'age':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '年龄',
                        type: 0,
                        questionContent: 'age',
                        optionContent: [],
                        disabled: 1,
                        required: false,
                    });
                    break;
                case 'area':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '地区',
                        type: 12,
                        questionContent: 'area',
                        optionContent: [],
                        disabled: 1,
                        required: false,
                    });
                    break;
                case 'phone':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '手机',
                        type: 5,
                        questionContent: 'phone',
                        optionContent: [],
                        disabled: 1,
                        required: false,
                        isOpenSms: false,
                    });
                    break;
                case 'telephone':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '电话',
                        type: 6,
                        questionContent: 'telephone',
                        optionContent: [],
                        disabled: 1,
                        required: false,
                    });
                    break;
                case 'email':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '邮箱',
                        type: 7,
                        questionContent: 'email',
                        optionContent: [],
                        disabled: 1,
                        required: false,
                    });
                    break;
                case 'personalWeb':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '个人网站',
                        type: 0,
                        questionContent: 'personalWeb',
                        optionContent: [],
                        disabled: 1,
                        required: false,
                    });
                    break;
                case 'company':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '公司/单位',
                        type: 0,
                        questionContent: 'company',
                        optionContent: [],
                        disabled: 1,
                        required: false,
                    });
                    break;
                case 'companyWeb':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '公司网站',
                        type: 0,
                        questionContent: 'companyWeb',
                        optionContent: [],
                        disabled: 1,
                        required: false,
                    });
                    break;
                case 'position':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '职位',
                        type: 0,
                        questionContent: 'position',
                        optionContent: [],
                        disabled: 1,
                        required: false,
                    });
                    break;
                case 'protocal':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '用户协议',
                        type: 8,
                        questionContent: 'protocol',
                        optionContent: [],
                        disabled: 0,
                        required: true,
                        userAgreement: '',
                        imgList: [],
                    });
                    break;
                case 'inviteCode':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '邀请码',
                        type: 9,
                        questionContent: 'inviteCode',
                        optionContent: [],
                        disabled: 0,
                        required: false,
                        inviteCode: '',
                    });
                    break;
                case 'updatenick':
                    this.questionnaireForm.surveyQuestions.push({
                        title: '修改昵称',
                        type: 10,
                        questionContent: 'updatenick',
                        optionContent: [],
                        disabled: 0,
                        required: false,
                    });
                    break;
                default:
                    return;
            }

            if (protocal) {
                this.questionnaireForm.surveyQuestions.push(protocal);
            }
            //input焦点
            this.$nextTick(() => {
                const titleInputArr = document.querySelectorAll('.titleInput');
                const titleInput = titleInputArr[titleInputArr.length - 1];
                titleInput.querySelector('input').focus();
                titleInputArr[titleInputArr.length - 1].scrollIntoView();
            });

            this.$nextTick(() => {
                this.initQuill();
            });
        },
        // options组件使用的删除问题
        removeQuestion(option) {
            this.questionnaireForm.surveyQuestions.forEach((item, itemIndex) => {
                let deleteIndex = -1;
                if (option.type == 0) {
                    if (item.title === option.title) {
                        deleteIndex = itemIndex;
                    }
                } else {
                    if (item.type === option.type) {
                        deleteIndex = itemIndex;
                    }
                }
                if (deleteIndex > -1) {
                    this.questionnaireForm.surveyQuestions.splice(deleteIndex, 1);
                }
            });
        },
        //删除问题
        deleteQuestion(index) {
            this.$refs.options.remove(this.questionnaireForm.surveyQuestions[index]);
            this.questionnaireForm.surveyQuestions.splice(index, 1);
        },
        //复制问题
        copyQuestion(index) {
            // var question = Object.assign({}, this.questionnaireForm.surveyQuestions[index]);
            var question = JSON.parse(JSON.stringify(this.questionnaireForm.surveyQuestions[index]));
            if (question.id) {
                delete question.id;
            }
            // var surveyQuestions = Object.assign([],this.questionnaireForm.surveyQuestions);
            var surveyQuestions = JSON.parse(JSON.stringify(this.questionnaireForm.surveyQuestions));
            surveyQuestions.push(question);
            this.questionnaireForm.surveyQuestions = surveyQuestions;
            this.questionnaireForm.surveyQuestions.forEach((item, index) => {
                item.optionContent.forEach((optionContentItem) => {
                    if (optionContentItem.type === 1) {
                        this.$nextTick(() => {
                            const otherOption = document
                                .querySelectorAll('.dragBox')
                            [index].querySelector('.addOtherOption');
                            otherOption.style.color = '#c2c5cc';
                        });
                    }
                });
            });
        },
        async uploadSelect(file, index) {
            const body = new FormData();
            body.append('file', file.file);

            let res = await survey.options(body);
            if (res.ok) {
                const optionContent = Object.assign([], this.questionnaireForm.surveyQuestions[index].optionContent);
                this.questionnaireForm.surveyQuestions[index].optionContent = [...optionContent, ...res.data.data];
            }
        },
        //添加问题选项
        addOption(type, index) {
            // console.log('添加',index)
            const optionContent = Object.assign([], this.questionnaireForm.surveyQuestions[index].optionContent);
            if (type === 1) {
                let otherOption = true;
                optionContent.forEach((item) => {
                    if (item.type === 1) {
                        otherOption = false;
                    }
                });
                if (otherOption) {
                    optionContent.push({
                        type: 1,
                        value: '',
                    });

                    const otherOption = document.querySelectorAll('.dragBox')[index].querySelector('.addOtherOption');
                    // console.log(otherOptionList)
                    // console.log(index)
                    otherOption.style.color = '#c2c5cc';
                } else {
                    this.$message.error('其他项只能添加一项');
                }
            } else {
                optionContent.push({
                    type: 0,
                    value: '',
                });
                // console.log(this.questionnaireForm);
            }
            this.questionnaireForm.surveyQuestions[index].optionContent = optionContent;
            this.$nextTick(() => {
                let inputs = this.$refs.dragBox[index].querySelectorAll('.el-input__inner');
                inputs[inputs.length - 1].focus();
            });
        },
        //删除问题选项
        deleteOption(index, optionContentIndex) {
            var optionContent = Object.assign([], this.questionnaireForm.surveyQuestions[index].optionContent);
            optionContent.splice(optionContentIndex, 1);
            this.questionnaireForm.surveyQuestions[index].optionContent = optionContent;
            this.questionnaireForm.surveyQuestions.forEach((item, index) => {
                let haveOther = false;
                item.optionContent.forEach((optionContentItem) => {
                    if (optionContentItem.type === 1) {
                        haveOther = true;
                    }
                });
                // console.log(haveOther)
                if (!haveOther) {
                    this.$nextTick(() => {
                        // console.log(document.querySelectorAll('.dragBox')[index])
                        const otherOption = document
                            .querySelectorAll('.dragBox')
                        [index].querySelector('.addOtherOption');
                        otherOption.style.color = '#45a9ff';
                    });
                }
            });
        },
        //创建问卷提交
        submitForm(isSave) {
            if (this.questionnaireForm.surveyQuestions.length == 0) {
                this.$message.error('请添加表单信息');
                return;
            }
            this.$refs.questionnaireForm.validate((valid, value) => {
                this.titleHintShow = false;
                this.descriptionHintShow = false;
                if (valid) {
                    let questionList = JSON.parse(JSON.stringify(this.questionnaireForm.surveyQuestions));
                    let haveInviteCode = true; //是否有邀请码
                    const surveyQuestions = questionList.map((item, index) => {
                        if (item.type === 9 && item.inviteCode && item.inviteCode.length > 0) {
                            item.inviteCode = item.inviteCode.split(',');
                        }
                        if (item.type === 9 && !item.inviteCode) {
                            haveInviteCode = false; // 邀请码为空
                        }
                        return {
                            ...item,
                            orderd: index,
                            required: item.required ? 1 : 0,
                            optionContent: JSON.stringify(item.optionContent),
                        };
                    });
                    if (!haveInviteCode) {
                        // 提示邀请码不可为空，并中断请求
                        this.$message.error('请输入邀请码');
                        return;
                    }
                    let activityTitle = '';
                    if (this.bindActivity) {
                        const activity = this.listOptions.find(
                            (item) => item.value === this.questionnaireForm.activityId
                        );
                        if (activity) {
                            activityTitle = activity.label;
                        }
                    }
                    const params = {
                        type: this.type,
                        title: this.questionnaireForm.title,
                        description: this.questionnaireForm.description,
                        deadLine: this.questionnaireForm.deadLine,
                        visitType: this.questionnaireForm.visitType,
                        activityId: this.questionnaireForm.activityId,
                        activityTitle,
                        sendWay: this.questionnaireForm.sendWay,
                        surveyQuestions,
                        bgPicture: this.bgPicture,
                        baseSort: this.questionnaireForm.baseSort,
                    };

                    if (this.type == 1) {
                        params.showResult = this.showResult;
                    }
                    const handle = this.$route.params.handle;
                    console.log(handle);
                    switch (handle) {
                        case 'edit': {
                            console.log('编辑');
                            const id = this.$route.params.id;
                            params.id = +id;
                            params.status = isSave ? this.questionnaireForm.status : +!this.questionnaireForm.status;
                            survey.setQuestionnaireAndVote(params).then(({ data, ok }) => {
                                if (ok) {
                                    this.$message.success(data.msg);
                                    this.$router.push({
                                        name: this.type === 0 ? 'signList' : 'question',
                                        params: {
                                            type: this.type,
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            });
                            break;
                        }
                        case 'create': {
                            console.log('创建');
                            params.status = isSave ? 0 : 1;
                            // params.oldMark = 0; // 只有新建时为新版问卷
                            survey.addQuestionnaireAndVote(params).then(({ data, ok }) => {
                                if (ok) {
                                    this.$message.success(data.msg);
                                    // this.nowId = data.data.id;
                                    this.$router.push({
                                        name: this.type === 0 ? 'signList' : 'question',
                                        params: {
                                            type: this.type,
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            });
                            break;
                        }
                    }
                } else {
                    this.$message.error('请填写完整信息');
                }
            });
        },
        //打开设置弹窗事件
        setDialogOpen() {
            // if
            this.visitType = this.questionnaireForm.visitType;
            this.activityId = this.questionnaireForm.activityId;
            this.sendWay = this.questionnaireForm.sendWay;

            if (this.questionnaireForm.visitType != 0) {
                this.setDialogVisible = true;
            }
        },
        //关闭设置弹窗事件
        setDialogClose() {
            this.visitType = '';
            this.activityId = '';
            this.sendWay = '';
        },
        //设置弹窗保存事件
        setDialogSave() {
            // console.log(this.visitType)
            // console.log(this.activityId)
            // console.log(this.sendWay)
            if (this.bindActivity) {
                this.questionnaireForm.visitType = this.visitType;
                this.questionnaireForm.activityId = this.activityId;
                this.questionnaireForm.sendWay = this.sendWay;
                this.setDialogVisible = false;
            } else {
                this.questionnaireForm.visitType = 0;
                this.questionnaireForm.activityId = 0;
                this.setDialogVisible = false;
            }
        },
        //浏览
        showHandle() {
            sessionStorage.setItem('questionnaireForm', JSON.stringify(this.questionnaireForm));
            const pathname = window.location.pathname;
            window.open(`${pathname}#/questionnaireVote/noId/show`);
        },
        //验证选项不能重复
        validatePass(rule, value, callback) {
            const str = rule.field;
            // const rt= /\[\d\]/g.exec(str);
            const indexArr = str.match(/\d+/g);
            const surveyQuestionsIndex = indexArr[0] - 0;
            const optionContentIndex = indexArr[1] - 0;
            const optionContent = this.questionnaireForm.surveyQuestions[surveyQuestionsIndex].optionContent;
            // console.log(surveyQuestionsIndex, 'surveyQuestionsIndex');
            // console.log(optionContentIndex, 'optionContentIndex');
            // console.log(optionContent, 'optionContent');
            // console.log(value, 'value');
            var flag = true;
            for (let i = 0; i < optionContent.length; i++) {
                if (optionContentIndex !== i) {
                    if (optionContent[i].value === value) {
                        flag = false;
                        // callback(new Error('选项不能重复'));
                        break;
                    } else {
                        flag = true;
                        // callback();
                    }
                }
            }
            // console.log(flag,'flag');
            !flag ? callback(new Error('选项不能重复')) : callback();
            // this.otherRepetition(surveyQuestionsIndex,optionContentIndex);
            // this.$refs.questionnaireForm.validateField()

            // console.log(optionContent)
            // console.log(surveyQuestions)
            // console.log(surveyQuestionsIndex,optionContentIndex)
            // console.log(value)
            // console.log(callback)
        },
        //验证其他选项重复
        otherRepetition(surveyQuestionsIndex, optionContentIndex) {
            const optionContent = this.questionnaireForm.surveyQuestions[surveyQuestionsIndex].optionContent;
            for (let i = 0; i < optionContent.length; i++) {
                if (i !== optionContentIndex) {
                    this.$refs.questionnaireForm.validateField(
                        `surveyQuestions[${surveyQuestionsIndex}].optionContent[${i}].value`
                    );
                }
            }
        },
        // 上传文件
        async fcCodeFile(file) {
            try {
                const body = new FormData();
                body.append('file', file.raw);
                const { data, ok } = await survey.importInviteCode(body);
                if (!ok) {
                    return;
                }
                if (data && Array.isArray(data.data) && data.data.length > 0) {
                    let inviteCode = this.questionnaireForm.surveyQuestions[this.uploadInviteCodeIndex].inviteCode;
                    // 判断尾部书否存在"," 不存在则添加
                    if (inviteCode.lastIndexOf(',') === inviteCode.length - 1) {
                        this.questionnaireForm.surveyQuestions[this.uploadInviteCodeIndex].inviteCode =
                            inviteCode.concat(data.data.join(','));
                    } else {
                        this.questionnaireForm.surveyQuestions[this.uploadInviteCodeIndex].inviteCode =
                            inviteCode.concat(',' + data.data.join(','));
                    }
                }
                this.uploadInviteCodeIndex = null;
            } catch (error) {
                console.error(error);
            }
        },
        // 保存上传的列表index
        uploadIndex(index) {
            this.uploadInviteCodeIndex = index;
        },
    },
};
</script>
<style lang="less">
#setQuestionnaire {
    height: 100%;

    .layout-content {
        height: 100%;
        overflow: hidden;
        border-radius: 4px;
        display: flex;
        flex-direction: column;

        .layout-content-title {
            position: relative;
            z-index: 10;
            height: 64px;
            padding: 16px 16px 16px 24px;
            font-size: 14px;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
            display: flex;
            justify-content: space-between;
            align-items: center;

            .breadcrumb {
                display: flex;
                align-items: center;

                .iconpark-icon {
                    font-size: 20px;
                    margin-right: 16px;
                    cursor: pointer;
                }

                .el-breadcrumb__inner {
                    color: rgba(29, 33, 41, 1);
                    font-size: 18px;

                    &.is-link {
                        color: rgba(134, 144, 156, 1);
                        font-weight: normal;
                    }
                }

                .el-breadcrumb__separator {
                    font-size: 16px;
                }
            }

            .handleBtn {
                display: flex;
                align-items: center;

                .el-button {
                    height: 32px;
                    padding: 5px 16px;
                    border-radius: 2px;
                    margin-left: 16px;

                    span {
                        display: flex;
                        align-items: center;
                    }
                }

                .el-button--default {
                    border: 1px solid rgba(52, 145, 250, 1);
                    color: rgba(52, 145, 250, 1);

                    .iconpark-icon {
                        font-size: 16px;
                        margin-right: 4px;
                    }
                }

                .el-button--primary {
                    background: rgba(52, 145, 250, 1);
                }

                .iconpark-icon {
                    fill: rgba(52, 145, 250, 1);
                }
            }
        }

        .layout-container {
            background: rgba(242, 243, 245, 1);
            flex: 1 1 auto;
            display: flex;

            .container_left {
                flex: 0 1 auto;
                background: #ffffff;
                box-sizing: border-box;
                width: 252px;
                padding: 8px 16px 0;
                box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
            }

            .container_right {
                position: relative;
                flex: 1 1 auto;
                box-sizing: border-box;
                padding: 16px;
                height: calc(100vh - 70px);
                overflow-y: auto;
                .baseSortContainer {
                    .baseItem {
                        & + .baseItem {
                            margin-top: 20px;
                        }
                        .formItem {
                            margin-top: 0;
                        }
                    }
                }

                .posterUploader {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 120px;
                    position: relative;
                    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
                    border-radius: 2px;
                    overflow: hidden;

                    .handleBar {
                        display: flex;
                        align-items: center;
                        width: 90px;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        right: 0;
                        font-size: 20px;
                        cursor: pointer;
                        fill: #a9aeb8;
                    }

                    >div {
                        width: 100%;
                    }

                    img {
                        vertical-align: top;
                        border: none;
                    }

                    .tips {
                        width: 100%;
                        height: 100%;
                        color: rgba(134, 144, 156, 1);
                        font-size: 14px;
                        line-height: 22px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;

                        .iconpark-icon {
                            font-size: 56px;
                            margin-bottom: 10px;
                            fill: rgba(201, 205, 212, 1);
                        }
                    }

                    .el-upload {
                        width: 100%;
                        height: 100%;
                        display: block;
                        border-color: transparent;
                    }

                    .el-icon-close {
                        position: absolute;
                        top: 10px;
                        right: 10px;
                        color: #a9aeb8;

                        &:hover {
                            color: #3491fa;
                        }
                    }

                    .rawImg {
                        width: auto;
                        max-height: 120px;
                    }

                    .defaultImg {
                        position: absolute;
                        height: 100%;
                        width: 100%;
                        left: 0;
                        top: 0;
                        background: url('~@/assets/img/background.png') no-repeat center center;
                        background-size: cover;
                    }

                    .filterBlur {
                        position: absolute;
                        height: 100%;
                        width: 100%;
                        left: 0;
                        top: 0;
                        z-index: -1;
                        filter: blur(25px);
                    }
                }

                .formItem {
                    background: rgba(255, 255, 255, 1);
                    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
                    border-radius: 2px;
                    overflow: hidden;
                    margin-top: 20px;
                }

                .title {
                    padding: 20px 95px;
                    position: relative;

                    .handleBar {
                        display: flex;
                        align-items: center;
                        width: 90px;
                        position: absolute;
                        top: 30px;
                        right: 0;
                        font-size: 20px;
                        cursor: pointer;
                        fill: #a9aeb8;
                    }

                    .el-input__inner {
                        font-size: 20px;
                        text-align: center;
                    }

                    .el-form-item+.el-form-item {
                        margin-top: 22px;

                        .el-input__inner {
                            font-size: 16px;
                        }
                    }

                    .el-input__inner,
                    .el-textarea__inner {
                        border-color: transparent;
                    }

                    .el-textarea__inner {
                        min-height: 40px !important;
                        line-height: 28px;
                    }

                    .el-input.is-active .el-input__inner,
                    .el-input__inner:focus,
                    .el-input__inner:hover {
                        border-color: rgba(52, 145, 250, 1);
                        outline: 0;
                    }

                    .el-textarea.is-active .el-textarea__inner,
                    .el-textarea__inner:focus,
                    .el-textarea__inner:hover {
                        border-color: rgba(52, 145, 250, 1);
                        outline: 0;
                    }

                    .el-form-item.is-error .el-input__inner,
                    .el-form-item.is-error .el-input__inner:focus,
                    .el-form-item.is-error .el-textarea__inner,
                    .el-form-item.is-error .el-textarea__inner:focus,
                    .el-message-box__input input.invalid,
                    .el-message-box__input input.invalid:focus {
                        border-color: #f56c6c;
                    }
                }

                .el-input__inner,
                .el-textarea__inner {
                    border-radius: 0;
                    height: 36px;
                }

                .el-input.is-active .el-input__inner,
                .el-input__inner:focus {
                    border-color: rgba(52, 145, 250, 1);
                    outline: 0;
                }

                .el-textarea.is-active .el-textarea__inner,
                .el-textarea__inner:focus {
                    border-color: rgba(52, 145, 250, 1);
                    outline: 0;
                }

                .el-form {
                    .el-upload--picture-card {
                        width: 118px;
                        height: 118px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }

                    .el-form-item {
                        margin-bottom: 0px;

                        .el-form-item__content {
                            word-wrap: break-word;
                        }
                    }

                    #addHint {
                        height: 132px;
                        text-align: center;
                        box-sizing: border-box;
                        padding: 33px 0;
                        background: #f4f7fa;

                        .el-form-item__content {
                            .iconpark-icon {
                                height: 32px;
                                width: 32px;
                                color: rgba(134, 144, 156, 1);
                            }

                            p {
                                color: rgba(134, 144, 156, 1);
                                font-size: 12px;
                                line-height: 18px;
                            }
                        }
                    }

                    .dragBox {
                        box-sizing: border-box;
                        padding: 24px 458px 24px 56px;
                        margin-bottom: 0;
                        position: relative;
                        background: rgba(255, 255, 255, 1);
                        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
                        border-radius: 2px;
                        margin-top: 16px;

                        .el-form-item__content {
                            line-height: 36px;
                        }

                        .hintItem {
                            .text {
                                display: block;
                                width: 45px;
                                color: #b8bcc4;
                                padding-left: 15px;
                                position: relative;
                            }

                            .otherInput {
                                width: 100%;
                                .el-input {
                                    display: block;
                                }

                                .line {
                                    width: 100%;
                                    height: 40px;
                                    box-sizing: border-box;
                                    border-bottom: 1px solid #b8bcc4;
                                    display: inline-block;
                                }
                            }
                        }

                        .index {
                            position: absolute;
                            width: 56px;
                            top: 0;
                            left: -56px;
                            text-align: right;
                            padding-right: 12px;
                            font-size: 16px;
                            line-height: 36px;
                        }

                        .requiredBtn {
                            position: absolute;
                            top: 0;
                            right: -68px;
                            color: rgba(78, 89, 105, 1);
                            font-weight: normal;
                        }

                        .moveAndDelete {
                            position: absolute;
                            top: 8px;
                            right: -445px;
                            display: flex;
                            align-items: center;

                            .iconpark-icon {
                                font-size: 20px;
                                margin-right: 20px;
                                cursor: pointer;
                                fill: rgba(169, 174, 184, 1);

                                &:hover {
                                    fill: rgba(52, 145, 250, 1);
                                }
                            }
                        }

                        .survey_operate {
                            margin-top: 16px;
                            color: #606266;
                            display: flex;
                            align-items: center;

                            .el-upload {
                                span {
                                    display: flex;
                                    align-items: center;
                                    font-size: 14px;
                                    line-height: 22px;
                                }
                            }

                            .btn {
                                display: inline-flex;
                                align-items: center;
                                color: #45a9ff;
                                font-size: 14px;
                                line-height: 22px;
                                text-decoration: none;
                                cursor: pointer;
                            }

                            .line {
                                display: inline-flex;
                                width: 1px;
                                height: 8px;
                                background-color: rgba(229, 230, 235, 1);
                                margin: 0 12px;
                            }

                            .iconpark-icon {
                                font-size: 16px;
                                margin-right: 4px;
                                fill: rgba(52, 145, 250, 1);
                            }
                        }

                        .optionItem {
                            margin-top: 20px;
                            position: relative;

                            .iconpark-icon {
                                position: absolute;
                                top: 8px;
                                right: -32px;
                                font-size: 20px;
                                fill: rgba(169, 174, 184, 1);
                                cursor: pointer;
                            }
                        }

                        .add {
                            margin-top: 16px;
                            color: #606266;
                            display: flex;
                            align-items: center;

                            a {
                                display: inline-flex;
                                align-items: center;
                                cursor: pointer;
                                font-size: 14px;
                                line-height: 22px;

                                .iconpark-icon {
                                    font-size: 16px;
                                    margin-right: 4px;
                                    fill: rgba(52, 145, 250, 1);
                                }
                            }

                            .addOption {
                                color: rgba(52, 145, 250, 1);
                            }

                            .line {
                                display: inline-flex;
                                width: 1px;
                                height: 8px;
                                background-color: rgba(229, 230, 235, 1);
                            }

                            .addOtherOption {
                                color: rgba(52, 145, 250, 1);

                                b {
                                    position: relative;

                                    &.leftTop {
                                        top: -6px;
                                    }

                                    &.rightBottom {
                                        bottom: -7px;
                                    }
                                }
                            }

                            .maxChoose {
                                color: rgba(52, 145, 250, 1);

                                .el-input-number {
                                    width: 88px;
                                    height: 26px;
                                    line-height: 24px;
                                    margin: 0 8px;
                                }

                                .el-input {
                                    .el-input__inner {
                                        height: 26px;
                                        line-height: 24px;
                                    }
                                }

                                .tips {
                                    color: rgba(134, 144, 156, 1);
                                }
                            }
                        }

                        .ql-editor.ql-blank::before {
                            font-style: normal;
                        }
                    }
                }
            }
        }

        .sms_code_switch {
            margin-top: 16px;
            width: 100%;
            box-sizing: border-box;
            line-height: 1;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;

            .switch {
                margin-left: 32px;
            }
        }

        .sms_code_tips_wrap {
            margin-top: 14px;
            box-sizing: border-box;
            width: 100%;
            padding: 16px;
            background-color: #eaeef2;

            .sms_code_num {
                width: 100%;
                line-height: 1;
                font-size: 14px;
                color: #1d2129;

                .num {
                    color: #ff880f;
                }

                .buy_link {
                    margin-left: 16px;
                    display: inline-flex;
                    flex-flow: row nowrap;
                    align-items: center;
                    text-decoration: none;
                    color: #2c7dfa;

                    .icon {
                        transform: rotate(-90deg);
                        font-size: 12px;
                    }
                }
            }

            .sms_code_tips {
                margin-top: 8px;
                width: 100%;
                font-size: 13px;
                color: #8f98a8;
                line-height: 1;
            }
        }
    }

    .el-dialog {
        .el-dialog__header {
            padding: 30px;

            .el-dialog__title {
                font-size: 22px;
            }
        }

        .el-dialog__body {
            padding: 10px 92px 10px 73px;
            display: flex;
            flex-direction: column;

            .el-checkbox {
                margin-left: 0px;

                .el-checkbox__label {
                    font-size: 16px;
                }
            }

            .content {
                padding: 16px 0;
                box-sizing: border-box;
                padding-left: 25px;

                .el-row {
                    margin-bottom: 12px;

                    .el-col-6 {
                        line-height: 30px;
                    }
                }
            }
        }
    }

    .setDialog {
        .text {
            font-size: 16px;
            position: relative;

            .el-checkbox {
                position: absolute;
                left: -20px;
                top: 1px;
            }

            .el-switch {
                .el-switch__core {
                    margin: 5px;
                }
            }
        }

        .content {
            .el-row {
                .el-col {
                    padding: 0;
                    margin-bottom: 10px;
                }
            }
        }
    }

    .previewDialog {
        .el-dialog__body {
            padding-bottom: 50px;
        }
    }

    .tipsDialog {
        .el-dialog {
            .el-dialog__header {
                border-bottom: 1px solid #d8dbe0;
            }

            .el-dialog__body {
                padding: 28px 30px;

                p {
                    line-height: 28px;
                    margin-bottom: 11px;

                    &+p {
                        margin-bottom: 37px;
                    }
                }

                img {
                    width: 229px;
                    margin-left: 20px;
                }
            }
        }
    }
}

.simulationUpload {
    cursor: pointer;
    width: 100px;
    height: 100px;
    background: rgba(242, 243, 245, 1);
    border: 1px dashed rgba(229, 230, 235, 1);
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: rgba(78, 89, 105, 1);
    font-size: 14px;
    line-height: 22px;

    .iconpark-icon {
        margin-bottom: 10px;
        color: rgba(78, 89, 105, 1);
    }
}

.edit_box {
    .edit_form-item {
        position: relative;
        margin-top: 16px;
        color: #4e5969;
    }

    .live_title {
        display: flex;
        align-items: center;
        flex-flow: row nowrap;

        span {
            font-size: 14px;
            line-height: 22px;
            color: #9098a8;
        }

        .icon-bangzhu {
            font-size: 15px;
            margin-left: 8px;
            margin-right: 0px;
            vertical-align: initial;
            cursor: pointer;
            color: #2b313c;

            &:hover {
                color: #5d6574;
            }
        }
    }

    .screen {
        position: absolute;
        top: 55px;
        right: 19px;
        font-size: 20px;
        color: #5d6574;
        z-index: 1;
        cursor: pointer;
    }

    .closescreen {
        position: fixed;
        top: 16px;
        right: 19px;
        font-size: 16px;
        color: #5d6574;
        z-index: 1999;
        cursor: pointer;
    }

    .screen:hover,
    .closescreen:hover {
        color: #06c;
    }

    .quill-editor {
        width: 100%;
        position: relative;

        .ql-toolbar {
            border-radius: 2px 2px 0 0;
            background-color: #fff;
            padding: 10px 8px;

            .ql-picker {
                .ql-picker-label {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;

                    &::before {
                        max-width: 91px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }

        .ql-container {
            height: 299px;
            border-radius: 0px 0px 2px 2px;
        }

        img {
            max-width: 400px;
        }

        .ql-loop(@i) when (@i < 10) {
            p.ql-indent-@{i} {
                text-indent: 2em * @i;
                padding-left: 0;
            }

            ol li.ql-indent-@{i} {
                margin-left: 2em * @i;
                list-style-type: decimal;
                padding-left: 0;
            }

            ul li.ql-indent-@{i} {
                margin-left: 2em * @i;
                padding-left: 0;
            }

            ol li.ql-indent-@{i}:before {
                display: none;
            }

            // .ql-indent-@{i}:not(.ql-direction-rtl){
            // 	padding-left: 0;
            // }
            .ql-loop(@i + 1);
        }

        .ql-loop(1);
    }

    .screenQuillEditor {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        margin-top: 0;
        z-index: 1998;
        background-color: #fff;

        .ql-container {
            height: calc(~'100% - 72px');
        }

        .ql-snow {
            border: 1px solid transparent;
            border-top: 1px solid #e2e5e7;
        }
    }
}

.ql-container {
    z-index: auto !important;
}

.setQuestionnaireQrCode {
    .setQuestionnaireQrCodeBox {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            width: 128px;
            height: 128px;
        }

        div {
            margin-top: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: rgba(16, 16, 16, 1);
            font-size: 14px;

            .preview {
                color: rgba(56, 108, 255, 1);
                cursor: pointer;
                margin-top: 4px;
            }
        }
    }
}
</style>
